import React from "react"
import { Provider } from "react-redux"
import "react-toastify/dist/ReactToastify.css"
import { PersistGate } from "redux-persist/integration/react"
import store, { persistor } from "./src/redux/store"
import "./src/styles/globals.css"
import "./src/styles/style.css"
import ResponsiveToast from "./src/components/atoms/ResponsiveToastContainer"
// Wrap root element with Redux Provider
export const wrapRootElement = ({ element }) => (
  <Provider store={store}>
    <PersistGate persistor={persistor} loading={null}>
      {element}
      <ResponsiveToast />
    </PersistGate>
  </Provider>
)
